import React from "react"
import { BaseEmptyState, BaseEmptyStateProps } from "./BaseEmptyState"

type Props = {} & Omit<BaseEmptyStateProps, "type">

export const TertiaryEmptyState: React.FC<Props> = (props) => <BaseEmptyState type="tertiary" {...props} />
